export default __webpack_public_path__ + "static/media/api3-logo.ea5a7548.png";